import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import type { ReactNode } from 'react'

export interface InvestigationTab {
  id: string
  label: string
  content: ReactNode
}

export interface InvestigationSpineProps {
  title: string
  contextStrip: ReactNode
  actionBar: ReactNode
  tabs: InvestigationTab[]
  defaultTabId?: string
}

export function InvestigationSpine({
  title,
  contextStrip,
  actionBar,
  tabs,
  defaultTabId,
}: InvestigationSpineProps) {
  const first = defaultTabId ?? tabs[0]?.id
  return (
    <div className="grid grid-cols-12 gap-6 p-6">
      <aside role="complementary" className="col-span-12 lg:col-span-3">
        {contextStrip}
      </aside>
      <main role="main" className="col-span-12 lg:col-span-9">
        <header className="mb-4 flex items-center justify-between gap-4">
          <h1 className="text-xl font-semibold">{title}</h1>
          {actionBar}
        </header>
        <Tabs defaultValue={first}>
          <TabsList>
            {tabs.map((t) => (
              <TabsTrigger key={t.id} value={t.id}>
                {t.label}
              </TabsTrigger>
            ))}
          </TabsList>
          {tabs.map((t) => (
            <TabsContent key={t.id} value={t.id}>
              {t.content}
            </TabsContent>
          ))}
        </Tabs>
      </main>
    </div>
  )
}
